import { render } from "./BudgetUpdate.vue?vue&type=template&id=df458284&scoped=true"
import script from "./BudgetUpdate.vue?vue&type=script&lang=js"
export * from "./BudgetUpdate.vue?vue&type=script&lang=js"

import "./BudgetUpdate.vue?vue&type=style&index=0&id=df458284&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df458284"]])

export default __exports__